import { Group, SegmentedControl, Stack, Text } from "@mantine/core";
import { IconCode, IconWebhook } from "@tabler/icons-react";
import { useSessionStore } from "../../../../stores/UserStore";
import { useNavigate, useParams } from "react-router-dom";
import Integration from "./integration/Integration";
import API from "./api/API";
import { useLanguage } from "../../../../stores/LanguageStore";

const Integrations = () => {
  const lang = useLanguage((s) => s.language);
  const { tab } = useParams();
  const navigate = useNavigate();

  return (
    <Stack gap={0} pr={48} pt={16} h={"calc(100vh - 96px)"}>
      <Group gap={"md"} mb={16}>
        <Text size="xl" fw={600} mr={"auto"}>
          {lang.settings.links.integrations}
        </Text>

        <SegmentedControl
          size="md"
          w={500}
          ml={"auto"}
          value={tab}
          data={[
            {
              label: (
                <Group justify="center">
                  <IconCode />

                  <Text>
                    {"API " + useSessionStore.getState().reseller?.name}
                  </Text>
                </Group>
              ),
              value: "api",
            },
            {
              label: (
                <Group justify="center">
                  <IconWebhook />

                  <Text>{lang.settings.integrations}</Text>
                </Group>
              ),
              value: "main",
            },
          ]}
          onChange={(v) => {
            navigate(`/settings/integrations/${v}`);
          }}
        />
      </Group>

      {tab === "main" ? <Integration /> : <API />}
    </Stack>
  );
};

export default Integrations;
